import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	dragIndicator: {
		id: 'portal-settings-request-groups.portal-group.group-header.drag-indicator',
		defaultMessage: 'Use arrow keys to reorder group',
		description: 'Aria label for the drag handler',
	},
	removeGroupButton: {
		id: 'portal-settings-request-groups.portal-group.group-header.remove-group-button',
		defaultMessage: 'Remove a group of {groupName}',
		description: 'Aria label for the remove group button',
	},
	openGroupButtonAria: {
		id: 'portal-settings-request-groups.portal-group.group-header.open-group-button-aria',
		defaultMessage: 'List of request forms for {groupName}',
		description: 'Aria label for the open group button',
	},
	removeIconTooltip: {
		id: 'portal-settings-request-groups.portal-group.group-header.remove-icon-tooltip',
		defaultMessage: 'Delete group',
		description: 'Text to show in tooltip on hover of the remove icon',
	},
	inputPlaceholder: {
		id: 'portal-settings-request-groups.portal-group.group-header.input-placeholder',
		defaultMessage: 'Enter group name',
		description: 'Text to show in input when it is empty',
	},
	groupNameDuplicateError: {
		id: 'portal-settings-request-groups.portal-group.group-header.group-name-duplicate-error',
		defaultMessage: 'This name is already in use, try another.',
		description: 'Error message to display when new group name already in use',
	},
	editButtonLabel: {
		id: 'portal-settings-request-groups.portal-group.group-header.edit-button-label',
		defaultMessage: 'Edit Portal Group, {groupName}',
		description: 'Aria label for the edit protal group button',
	},
});
